exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons-component div{display:flex;align-items:center}.buttons-component .ant-btn-group{margin-left:6px}body .divide-btn{margin-left:6px;border-top-right-radius:0!important;border-bottom-right-radius:0!important}body .margin-left-1{margin-left:1px!important;width:18px;border-top-left-radius:0!important;border-bottom-left-radius:0!important;display:flex;justify-content:center;align-items:center;padding:0}body .margin-left-1 .iconfont{font-size:12px}", ""]);

// exports
